import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { FlatpickrDirective, provideFlatpickrDefaults } from "angularx-flatpickr";
import dayjs from "dayjs";

import { ChangeDetectionStrategy, Component, effect, inject, input, output, signal } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { DnsFirewallSearchFilter } from "../../../apis/networkdashboard/graphql/graphql";
import { AuthService } from "../../../services/authservice";
import { CustomDropdown, CustomDropdownOption } from "../../common/custom-dropdown/custom-dropdown";

@Component({
  selector: "cert-filter-dns",
  templateUrl: "cert-filter.html",
  styleUrl: "cert-filter.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomDropdown, AngularSvgIconModule, FormsModule, TranslatePipe, FlatpickrDirective],
  providers: [provideFlatpickrDefaults()],
})
export class CertFilterDns {
  private auth = inject(AuthService);

  protected prefixes = input<string[]>([]);
  public filtersChanged = output<DnsFirewallSearchFilter>();

  protected initialStartDate = dayjs().subtract(7, "day").startOf("day").toDate();
  protected initialEndDate = dayjs().endOf("day").toDate();

  protected rpzFeedOptions = signal([
    { id: 1, select: false, name: "Misc", value: "Misc" },
    { id: 2, select: false, name: "Phishing", value: "Phishing" },
    { id: 3, select: false, name: "Malware", value: "Malware" },
    { id: 4, select: false, name: "SURFcert MISP", value: "SURFcert MISP" },
  ]);
  protected ip = "";

  protected prefixOptions = signal<CustomDropdownOption[]>([]);

  constructor() {
    effect(() => {
      this.prefixOptions.set(
        this.prefixes()
          .map((prefix, index) => ({ id: index, select: false, name: prefix }))
          .sort((a, b) => a.name.localeCompare(b.name)),
      );
      this.filtersChanged.emit(this.searchFilter());
    });
  }

  protected submit() {
    this.filtersChanged.emit(this.searchFilter());
  }

  private searchFilter() {
    const filter: DnsFirewallSearchFilter = {
      customerId: this.auth.viewingCustomer().customerId,
      beforeRecordedAt: dayjs(this.initialEndDate).endOf("day").toDate(),
      afterRecordedAt: dayjs(this.initialStartDate).startOf("day").toDate(),
    };

    const selectedPrefixes = this.prefixOptions().filter((prefix) => prefix.select);
    const selectedClassifications = this.rpzFeedOptions().filter((rpz) => rpz.select);

    if (selectedPrefixes.length) {
      filter.ipPrefixes = selectedPrefixes.map((prefix) => prefix.name);
    }

    if (selectedClassifications.length) {
      filter.rpzFeed = selectedClassifications.map((rpz) => rpz.value);
    }

    if (this.ip !== "") {
      filter.ipAddress = `${this.ip}`.trim().replace(/[^0-9.]/g, "");
    }

    return filter;
  }

  protected resetFilters() {
    this.ip = "";
    this.prefixOptions.update((opts) => opts.map((p) => ({ ...p, select: false })));
    this.rpzFeedOptions.update((opts) => opts.map((r) => ({ ...r, select: false })));
    this.initialStartDate = dayjs().subtract(7, "day").startOf("day").toDate();
    this.initialEndDate = dayjs().endOf("day").toDate();
    this.filtersChanged.emit(this.searchFilter());
  }
}
